import { EdgeTypes } from '@xyflow/react';

import CustomEdge from './custom-edge';

const edgeTypes: EdgeTypes = {
  custom: CustomEdge,
};

export default edgeTypes;
